// extracted by mini-css-extract-plugin
export default {"content":"BaseLayout_content__KLDRS","contentWithPadding":"BaseLayout_contentWithPadding__rnSJZ"};